
/* 
Collapseable Menu Button Animation
*/

(function ($) {



    // Menu animations
    $('#trigger').on('click', function(){

        if($(this).hasClass('open')){
            $('#mainMenu').removeClass('is-active');
            $(this).removeClass('open');
            $('body').removeClass('disable');
            $('#siteLogo').animate({}, 1000, function(){
                $(this).removeClass('reposition');
            });
            $('#header__contact-button').animate({}, 1000, function(){
                $(this).removeClass('reposition');
            });
            

        } else {

            $('body').addClass('disable');
            $(this).addClass('open');
            $('#mainMenu').addClass('is-active');
            $('#siteLogo').addClass('reposition');
            $('#siteLogo').animate({}, 750, function(){
                $(this).css('z-index', 90);
            });
            $('#header__contact-button').addClass('reposition');
            $('#header__contact-button').animate({}, 750, function(){
                $(this).css('z-index', 90);
            });

        }

    });

    $('#mainMenu a').on('click', function(){

        if($('#trigger').hasClass('open')){

            $('#trigger').removeClass('open');
            $('body').removeClass('disable');
            $('#siteLogo').animate({}, 1000, function(){
                $(this).removeClass('reposition');
            });
            $('#header__contact-button').animate({}, 1000, function(){
                $(this).removeClass('reposition');
            });
            $('#mainMenu').animate({top: '-100vh'}).fadeOut(1000);

        }

    });

})(jQuery);
